import { createApp } from 'vue';
import { createGtm } from '@gtm-support/vue-gtm';
import App from './App.vue';
import router from './router';
import store from './store';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import '@/assets/styles/main.scss';

const app = createApp(App);

app.use(store);

app.use(router);

app.use(
  createGtm({
    id: 'GTM-T9HVP5K',
    defer: false,
    compatibility: false,
    enabled: true,
    debug: true,
    loadScript: true,
    trackOnNextTick: false,
  })
);

Bugsnag.start({
  apiKey: '443e0a6081ecbf6085a1a072a45a901b',
  plugins: [new BugsnagPluginVue()],
  releaseStage: process.env.NODE_ENV,
  enabledReleaseStages: ['staging', 'production'],
  appVersion: 'v1.0.0',
});

const bugsnagVue = Bugsnag.getPlugin('vue');
app.use(bugsnagVue);

app.mount('#app');
